export default __webpack_public_path__ + "static/media/logo-stars-group.489c2e42.svg";